"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDetails = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var filesize_1 = __importDefault(require("filesize"));
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importStar(require("react"));
var react_confirm_alert_1 = require("react-confirm-alert");
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
/* Imported CSS */
require("react-confirm-alert/src/react-confirm-alert.css");
require("./PackageDetails.scss");
/* Blast Imports */
var PackageHeader_1 = require("./PackageHeader");
var PackageRecipients_1 = require("./PackageRecipients");
var actions_1 = require("../state/actions");
var models_1 = require("@app/_state/models");
var InfoIcon_1 = require("@app/components/controls/InfoIcon");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var PackageProgressBar_1 = require("@app/components/packages/PackageProgressBar");
var PauseButton_1 = require("@app/components/packages/PauseButton");
var RetryButton_1 = require("@app/components/packages/RetryButton");
var Avatar_1 = require("@app/components/users/Avatar");
var UserAvatar_1 = require("@app/components/users/UserAvatar");
var PackageFiles_1 = require("@app/features/package-files/components/PackageFiles");
var actions_2 = require("@app/features/package-files/state/actions");
var actions_3 = require("@app/features/transfers/state/actions");
var models_2 = require("@app/features/transfers/state/models");
var selectors_1 = require("@app/features/transfers/state/selectors");
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var api_1 = require("@server/types/api");
var initialState = {
    downloadProgressVisible: false
};
var ForwardPackageButton = function (props) { return (react_1.default.createElement("div", { className: classnames_1.default('forward-button', { tooltip: props.disabled }, { 'is-tooltip-left': props.disabled }), style: { lineHeight: '1rem' }, "data-tooltip": props.disabled ? props.disabledText : undefined },
    react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/upload/" + props.packageId, className: classnames_1.default('button', { disabled: (props.disabled) }), "data-test": "forward-pkg-link" },
        react_1.default.createElement("span", { className: "icon" },
            react_1.default.createElement("i", { className: "fas fa-redo-alt" })),
        props.showText &&
            react_1.default.createElement("span", null, "Forward")))); };
/**
 * Blast's Package Details component, displays all the details for a specific package
 */
var PackageDetails = /** @class */ (function (_super) {
    __extends(PackageDetails, _super);
    function PackageDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleCollapse = function (file) {
            _this.props.onCollapse(file.path);
        };
        _this.handleDelete = function (packageId) {
            new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Delete Package');
            react_confirm_alert_1.confirmAlert({
                title: 'Expire Package?',
                message: 'Expiring a package will revoke access to the package for all recipients.',
                buttons: [{
                        label: 'Yes, expire package',
                        onClick: function () {
                            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Delete Package - Confirm', "" + packageId);
                            _this.props.onDeletePackage(packageId);
                        }
                    }, {
                        label: 'No',
                        onClick: function () { return log_1.default.info('Dismissed expire package confirmation'); }
                    }]
            });
        };
        _this.handleDownloadAll = function () {
            _this.setState({ downloadProgressVisible: true });
            if (_this.props.asperaEnabled) {
                _this.props.onConnectDownload(_this.props.packageDetails.id);
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("DOWNLOADING USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(_this.props.packageDetails);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("DOWNLOADING USING PLUGINLESS");
                    _this.props.onHttpDownload(_this.props.packageDetails);
                }
            }
            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Download Package', _this.props.packageDetails.id);
        };
        _this.handleDownloadRetry = function () {
            _this.setState({ downloadProgressVisible: true });
            if (_this.props.asperaEnabled) {
                if (_this.props.packageDetails && _this.props.packageDetails.packageTransferId) {
                    _this.props.onResumeConnectTransfer(_this.props.packageDetails.packageTransferId);
                }
                else {
                    _this.props.onConnectDownload(_this.props.packageDetails.id);
                }
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("RETRYING DOWNLOAD USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(_this.props.packageDetails);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("RETRYING DOWNLOAD USING PLUGINLESS");
                    _this.props.onHttpDownload(_this.props.packageDetails);
                }
            }
            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Retry Download Package', _this.props.packageDetails.id);
        };
        _this.handleDownloadStop = function (pkg) {
            if (pkg.packageTransferId) {
                _this.props.onStopConnectTransfer(pkg.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('Package Details', 'Stop Download Package', pkg.id);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + pkg.title + "' (" + pkg.id + ")");
            }
        };
        _this.handleExpand = function (file, expandDir) {
            var packageId = _this.props.packageId;
            _this.props.onExpand(packageId, file, expandDir);
        };
        _this.handleFileDownload = function (file) {
            _this.setState({ downloadProgressVisible: false });
            if (_this.props.asperaEnabled) {
                _this.props.onConnectDownload(_this.props.packageId, file.path);
            }
            else if (_this.props.httpGatewayStatus) {
                var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                    _this.props.onHttpGatewayDownload(_this.props.packageDetails, file);
                }
                else {
                    react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " files at a time.", {
                        autoClose: 10000,
                        toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                    });
                }
            }
            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Download Individual File', _this.props.packageDetails.id + " - " + file.path);
        };
        _this.handleFileDownloadRetry = function (file) {
            _this.setState({ downloadProgressVisible: false });
            if (file.fileTransferId) {
                _this.props.onResumeConnectTransfer(file.fileTransferId);
            }
            else {
                _this.props.onConnectDownload(_this.props.packageId, file.path);
            }
            new matomo_1.MatomoTracker().trackEvent('Package Details', 'Retry Download Individual File', _this.props.packageDetails.id + " - " + file.path);
        };
        _this.handleFileDownloadStop = function (file) {
            if (file.fileTransferId) {
                _this.props.onStopConnectTransfer(file.fileTransferId);
                new matomo_1.MatomoTracker().trackEvent('Package Details', 'Stop Download Individual File', file.path);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + file.path + "'");
            }
        };
        _this.handleGoBack = function () {
            if (_this.props.locationAction === 'REPLACE' || _this.props.locationAction === 'POP') {
                _this.props.onGoToDash();
            }
            else {
                _this.props.onGoBack();
            }
        };
        _this.handleOpenDownload = function () {
            if (_this.props.asperaEnabled && _this.props.packageDetails && _this.props.packageDetails.packageTransferId) {
                _this.props.onOpenDownload(_this.props.packageDetails.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('Package Details', 'Open Downloaded Package', _this.props.packageDetails.id);
            }
            else {
                react_toastify_1.toast.error('Couldn\'t open the downloaded package directory');
            }
        };
        _this.handleOpenFileDownload = function (file) {
            if (_this.props.asperaEnabled && file && file.fileTransferId) {
                _this.props.onOpenDownload(file.fileTransferId);
                new matomo_1.MatomoTracker().trackEvent('Package Details', 'Open Downloaded File', _this.props.packageDetails.id + " - " + file.name);
            }
            else {
                react_toastify_1.toast.error('Couldn\'t open the downloaded file');
            }
        };
        /*
        private handleOpenPreferences = (): void => {
          this.props.onOpenPreferences();
        };
        */
        _this.handleOpenTransferManager = function () {
            _this.props.onOpenTransferManager();
        };
        _this.renderDownloadButton = function () {
            var pkg = _this.props.packageDetails;
            if (!pkg) {
                return (react_1.default.createElement(react_1.default.Fragment, null));
            }
            var _a = _this.props, asperaEnabled = _a.asperaEnabled, downloadSizeLimitInMB = _a.downloadSizeLimitInMB, isDownloading = _a.isDownloading;
            var exceededDownloadSizeLimit = !asperaEnabled && (pkg.totalBytes > utils_1.megabytesToBytes(downloadSizeLimitInMB) || pkg.encrypted);
            var downloadAllButtonDisabled = _this.props.asperaInitializing ||
                pkg.state === models_1.PackageTransferState.IN_PROGRESS ||
                exceededDownloadSizeLimit ||
                isDownloading ||
                (pkg.totalBytes === 0) ||
                (_this.props.packageFiles.length === 0);
            var downloadAllButtonText = (pkg.state === models_1.PackageTransferState.IN_PROGRESS || isDownloading) ? 'Downloading' : (asperaEnabled ? 'Download All' : 'Download All As Zip');
            var isPackageComplete = pkg.state === models_1.PackageTransferState.COMPLETE;
            var isPackageCompleteRemoved = pkg.state === models_1.PackageTransferState.REMOVED && pkg.totalBytes === pkg.transferredBytes;
            var openButtonText = isDownloading ? 'Downloading' : 'Open';
            var showDownloadButton = (!react_device_detect_1.isMobile) ? true : ((react_device_detect_1.isIOS || react_device_detect_1.isWinPhone) ? false : react_device_detect_1.isAndroid /* ((isAndroid) ? true : false) */);
            if (!asperaEnabled || ((!isPackageComplete && !isPackageCompleteRemoved) || !pkg.packageTransferId)) {
                if (asperaEnabled && (pkg.state === models_1.PackageTransferState.FAILED || pkg.state === models_1.PackageTransferState.STOPPED)) {
                    return (react_1.default.createElement(RetryButton_1.RetryButton, { disabled: false, icon: 'fa-play', onDownload: pkg.packageTransferId ? _this.handleDownloadRetry : _this.handleDownloadAll, showTooltip: true, tooltipMessage: 'Resume Transfer' }));
                }
                else if (asperaEnabled && pkg.state === models_1.PackageTransferState.IN_PROGRESS) {
                    return (react_1.default.createElement(PauseButton_1.PauseButton, { disabled: false, onDownloadStop: function () { return _this.handleDownloadStop(pkg); }, showTooltip: true }));
                }
                else {
                    if (showDownloadButton) {
                        return (react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-yellow download-all-button", disabled: downloadAllButtonDisabled, onClick: pkg.packageTransferId ? _this.handleDownloadRetry : _this.handleDownloadAll }, downloadAllButtonText));
                    }
                    else {
                        return null;
                    }
                }
            }
            else {
                return (react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-yellow download-all-button", disabled: downloadAllButtonDisabled, onClick: _this.handleOpenDownload }, openButtonText));
            }
        };
        _this.renderExceededDownloadSizeLimitMessage = function () {
            var pkg = _this.props.packageDetails;
            var encryptedMsg = (pkg && pkg.encrypted) ?
                react_1.default.createElement("span", null, "Encrypted packages cannot be downloaded without the Aspera Connect plugin enabled. To download encrypted packages, please toggle \"Enable Aspera\" at the top of the page and install the Aspera Connect plugin.") : null;
            var sizeLimitMsg = (pkg && pkg.totalBytes > utils_1.megabytesToBytes(_this.props.downloadSizeLimitInMB)) ?
                react_1.default.createElement("span", null,
                    "You are limited to downloading packages that are ",
                    filesize_1.default(utils_1.megabytesToBytes(_this.props.downloadSizeLimitInMB)),
                    " or less. To download larger files, please toggle \"Enable Aspera\" at the top of the page and install the Aspera Connect plugin.") : null;
            return (react_1.default.createElement("article", { className: "message is-danger" },
                react_1.default.createElement("div", { className: "message-body" },
                    encryptedMsg &&
                        react_1.default.createElement("p", { className: "help" },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" })),
                            encryptedMsg),
                    sizeLimitMsg &&
                        react_1.default.createElement("p", { className: "help" },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" })),
                            sizeLimitMsg))));
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    PackageDetails.prototype.componentDidMount = function () {
        var packageId = this.props.packageId;
        this.props.onGetPackage(packageId, true);
    };
    PackageDetails.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.packageDetails === undefined && this.props.packageDetails !== undefined) {
            this.props.onGetPackageFiles(this.props.packageDetails.id);
            if (this.props.packageDetails && this.props.packageDetails.state && this.props.packageDetails.packageTransferId) {
                this.setState({ downloadProgressVisible: true });
            }
            else {
                this.setState({ downloadProgressVisible: false });
            }
        }
        // On refresh of package details page, the package state/transfer id may not be available yet to be caught by the prior statement
        if ((prevProps.packageDetails && (!prevProps.packageDetails.state || !prevProps.packageDetails.packageTransferId)) &&
            (this.props.packageDetails && this.props.packageDetails.state && this.props.packageDetails.packageTransferId)) {
            this.setState({ downloadProgressVisible: true });
        }
        if (prevProps.isDownloading && !this.props.isDownloading && (this.props.packageDetails && this.props.packageDetails.state)) {
            this.setState({ downloadProgressVisible: true });
        }
    };
    /* Component Methods - end */
    PackageDetails.prototype.render = function () {
        var _this = this;
        var pkg = this.props.packageDetails;
        var _a = this.props, asperaEnabled = _a.asperaEnabled, packageFiles = _a.packageFiles;
        if (!pkg) {
            return react_1.default.createElement("div", null);
        }
        var pkgExpired = pkg.pkgState === models_1.PackageState.DELETED || utils_1.hasExpirationDatePassed(pkg.expirationDate);
        var recipients = pkg.recipients;
        var exceededDownloadSizeLimit = !asperaEnabled && (pkg.totalBytes > utils_1.megabytesToBytes(this.props.downloadSizeLimitInMB) || pkg.encrypted);
        // Only show the expire (delete) package button if the pkg is not already expired and the sender is the currently logged-in user
        var deletePackageVisible = !pkgExpired && pkg.sender.userEmail === this.props.currentUserEmail;
        var packageIsForwardable = pkg.sender.userEmail === this.props.currentUserEmail ? true : !pkg.disableForwarding;
        var disabledForwardText = !packageIsForwardable ? 'The sender has disabled forwarding on this package.' : 'Forwarding this package is temporarily unavailable.\nCheck again at a later time.';
        var senderIsLoggedIn = pkg.sender.userEmail === this.props.currentUserEmail;
        return (react_1.default.createElement("div", { className: "package-details" },
            react_1.default.createElement("header", { className: "package-header-container" },
                react_1.default.createElement(PackageHeader_1.PackageHeader, { package: pkg, deletePackageVisible: deletePackageVisible, onGoBack: this.handleGoBack, onDeletePackage: function () { return _this.handleDelete(pkg.id); } })),
            react_1.default.createElement("div", { className: "box sender-message-details" },
                react_1.default.createElement("div", { className: "content is-hidden-tablet is-hidden-desktop is-hidden-fullhd" },
                    react_1.default.createElement("p", { className: "has-text-centered has-weight-bold" }, pkg.title)),
                react_1.default.createElement("div", { className: "level is-mobile" },
                    react_1.default.createElement("div", { className: "level-left is-half" },
                        react_1.default.createElement("div", { className: "level-item is-narrow" },
                            react_1.default.createElement(UserAvatar_1.UserAvatar, { user: pkg.sender })),
                        react_1.default.createElement("div", { className: "level-item is-narrow sender-info" },
                            react_1.default.createElement("p", { className: "has-text-weight-bold" },
                                pkg.sender.firstName,
                                " ",
                                pkg.sender.lastName),
                            react_1.default.createElement("p", null, pkg.sender.userEmail))),
                    react_1.default.createElement("div", { className: "level-right is-half" },
                        (this.props.isUserInternal || senderIsLoggedIn) && !pkgExpired &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("div", { id: "pkgDetails-fwd", className: "level-item is-narrow", "data-test": "forward-pkg-item" },
                                    react_1.default.createElement("div", { className: "field is-grouped" },
                                        react_1.default.createElement(ForwardPackageButton, { packageId: pkg.id, showText: true, disabled: (pkg.pkgState === models_1.PackageState.HELD) || !packageIsForwardable || pkg.totalBytes === 0, disabledText: disabledForwardText })))),
                        react_1.default.createElement("div", { id: "pkgDetails-recipient-label", className: "level-item is-narrow" },
                            react_1.default.createElement("p", { className: "has-text-weight-bold" }, "Recipients")),
                        react_1.default.createElement("div", { id: "pkgDetails-recipient-cnt", className: "level-item is-narrow" },
                            react_1.default.createElement("div", { className: "dropdown is-right is-hoverable" },
                                react_1.default.createElement("div", { className: "dropdown-trigger" },
                                    react_1.default.createElement(Avatar_1.Avatar, { text: recipients.length })),
                                react_1.default.createElement("div", { className: "dropdown-menu package-recipients", role: "menu" },
                                    react_1.default.createElement(PackageRecipients_1.PackageRecipients, { downloaders: pkg.downloaders, recipients: pkg.recipients })))))),
                pkg.encrypted &&
                    react_1.default.createElement("p", { className: "package-encrypted" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-lock", title: "Password Protected" })),
                        "This package is password protected"),
                react_1.default.createElement("p", { className: "package-message" }, pkg.note || 'No note for this package')),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column is-half is-offset-one-quarter" },
                    exceededDownloadSizeLimit && !pkgExpired &&
                        this.renderExceededDownloadSizeLimitMessage(),
                    react_1.default.createElement("div", { className: "download-all has-text-centered" },
                        !pkgExpired &&
                            this.renderDownloadButton(),
                        pkg.state && this.state.downloadProgressVisible &&
                            react_1.default.createElement("div", { className: "download-progress" },
                                react_1.default.createElement("div", { className: "download-progress-details has-text-weight-bold" },
                                    react_1.default.createElement("span", null, utils_1.getPackageTransferStateText(api_1.Direction.RECEIVE, pkg.state, pkg.totalBytes === pkg.transferredBytes)),
                                    react_1.default.createElement("span", null, utils_1.getPercentComplete(pkg.transferredBytes, pkg.totalBytes)),
                                    react_1.default.createElement("span", null, filesize_1.default(pkg.transferredBytes))),
                                react_1.default.createElement("div", { className: classnames_1.default('download-error', 'help', { 'is-danger': pkg.errorMsg }) },
                                    pkg.state === models_1.PackageTransferState.FAILED && pkg.errorMsg &&
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            pkg.errorMsg,
                                            ".",
                                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); _this.handleOpenTransferManager(); } }),
                                            pkg.errorDesc &&
                                                react_1.default.createElement(react_1.default.Fragment, null,
                                                    react_1.default.createElement("br", null),
                                                    pkg.errorDesc)),
                                    pkg.state === models_1.PackageTransferState.STOPPED &&
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            "This transfer has been stopped.",
                                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); _this.handleOpenTransferManager(); } })),
                                    pkg.state === models_1.PackageTransferState.WILLRETRY &&
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            "This transfer has failed and will retry approx. 30 seconds.",
                                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); _this.handleOpenTransferManager(); } })),
                                    pkg.state === models_1.PackageTransferState.QUEUED &&
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            "This transfer has been added to the queue.",
                                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); _this.handleOpenTransferManager(); } }))),
                                react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { state: pkg.state, transferredBytes: pkg.transferredBytes, totalBytes: pkg.totalBytes }))))),
            react_1.default.createElement(PackageFiles_1.PackageFiles, { asperaEnabled: this.props.asperaEnabled, files: packageFiles, fileStatus: true, downloadEnabled: (this.props.asperaEnabled || this.props.httpGatewayStatus) && !pkgExpired && (pkg.totalBytes > 0), downloadSizeLimitInMB: this.props.downloadSizeLimitInMB, encryptedPackage: !!pkg.encrypted, httpGatewayStatus: this.props.httpGatewayStatus, onExpand: this.handleExpand, onCollapse: this.handleCollapse, onDownload: this.handleFileDownload, onOpenDownload: this.handleOpenFileDownload, onRetry: this.handleFileDownloadRetry, onStop: this.handleFileDownloadStop, packageSize: pkg.totalBytes })));
    };
    return PackageDetails;
}(react_1.Component));
exports.PackageDetails = PackageDetails;
var mapStateToProps = function (store) {
    return {
        activeTransfersList: store.transfers.activeTransfers,
        httpGatewayStatus: store.transfers.httpGatewayStatus,
        isDownloading: store.packageDetails.isDownloading,
        packageDetails: store.packageDetails.packageDetails,
        packageFiles: store.packageFiles.packageFiles,
        asperaEnabled: selectors_1.isAsperaEnabled(store),
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        isUserBetaTester: store.auth.userInfo ? !!store.auth.userInfo.betaTestUser : false,
        isUserInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false,
        currentUserEmail: store.auth.userInfo ? store.auth.userInfo.userEmail : undefined,
        locationAction: store.router.action
    };
};
var mapDispatchToProps = {
    onCollapse: actions_2.collapseDirectory,
    onConnectDownload: actions_3.connectDownload,
    onDeletePackage: actions_1.deletePackage,
    onExpand: actions_2.expandDirectory,
    onGetPackage: actions_1.getPackage,
    onGetPackageFiles: actions_2.getPackageFiles,
    onGoBack: actions_1.onGoBack,
    onGoToDash: actions_1.onPushToDash,
    onHttpDownload: actions_3.httpDownload,
    onHttpGatewayDownload: actions_3.httpGatewayDownload,
    onOpenDownload: actions_3.showDirectory,
    onOpenPreferences: actions_3.showPreferences,
    onOpenTransferManager: actions_3.showTransferManager,
    onResumeConnectTransfer: actions_3.resumeConnectTransfer,
    onRetryHttpUpload: actions_3.retryHttpUpload,
    onStopConnectTransfer: actions_3.stopConnectTransfer
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PackageDetails);
